import React, { useEffect, useMemo } from 'react';
import TableTitle from '../components/TableTitle';
import { Table } from '../components/Table';
import Container from '../components/Container';
import { useEngineersStore } from '../features/engineers/state/use-engineers-store';
import { DeleteForever } from '@mui/icons-material';
import DeleteEngineer from '../features/engineers/DeleteEngineer';
import useRole from '../hooks/use-role';
import Pagination from '../components/Pagination/Pagination';
import usePagination from '../components/Pagination/usePagination';
import { useSearchParams } from 'react-router-dom';
import SortField from '../components/SearchBar/SortField';

const LIMIT = 20;
const SORT_OPTIONS = [
  { value: 'fio', name: 'ФИО' },
  { value: 'email', name: 'Email' },
  { value: 'phone', name: 'Номеру телефона' },
];
const sortName = 'sort';

const Engineers = () => {
  const { data, isLoading, error, fetchEngineers, setDeleteData, total } = useEngineersStore();
  const { isEngineer } = useRole();
  const { page, limit } = usePagination({ limit: LIMIT });
  const totalPages = Math.ceil(total / limit);

  const [searchParams] = useSearchParams();
  const currentSort = searchParams.get(sortName);

  useEffect(() => {
    fetchEngineers(page, limit, currentSort);
  }, [page, limit, currentSort]);

  const columns = useMemo(
    () => [
      {
        key: 'fio',
        title: 'ФИО',
      },
      {
        key: 'email',
        title: 'Email',
      },
      {
        key: 'phone',
        title: 'Телефон',
        render: (value) => <div className={'min-w-max'}>{value ?? ' - '}</div>,
      },
      ...(!isEngineer
        ? [
            {
              key: 'actions',
              title: 'Действия',
              render: (row) => (
                <div className={'text-center flex items-center justify-center w-20'}>
                  <button
                    onClick={() => {
                      setDeleteData({ id: row?.id, name: row?.fio, deleteModal: true });
                    }}
                    className="text-red-500 hover:text-red-600">
                    <DeleteForever />
                  </button>
                </div>
              ),
            },
          ]
        : []),
    ],
    [isEngineer, setDeleteData]
  );

  return (
    <>
      <Container>
        <div className="max-w-7xl mx-auto flex items-center justify-between mb-8 gap-4 flex-wrap">
          <TableTitle title={'Инженеры'} />
          <SortField label={'Сортировать по'} options={SORT_OPTIONS} params={sortName} classContainer={'max-w-[180px]'} />
        </div>
        <Table columns={columns} data={data ?? []} loading={isLoading} error={error}>
          {isLoading || error || totalPages === 0 ? null : <Pagination totalPages={totalPages} withLimit={true} initialLimit={LIMIT} />}
        </Table>
      </Container>
      <DeleteEngineer />
    </>
  );
};

export default Engineers;
